import React from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import { Field, Form } from 'react-final-form'; // eslint-disable-line no-unused-vars
import { Label } from '@americanexpress/dls-react'; // eslint-disable-line no-unused-vars
import { getTrimmedObjectValues, useValidationSchema, FxMultiButtons } from 'axp-fx-common'; // eslint-disable-line no-unused-vars
import { registerFormData } from '../registerFormInitData';
import labels from '../../../constants/labels';
import { steps } from '../../../constants/registration';
import { accountValidationSchema } from '../../../utils/registrationSchemaUtil';

const Account = (props) => {
  const {
 accountData, setAccountData, setRegistrationStep, dialCodes,
} = props;

  const handleNextButtonClick = (formValues) => {
    const updatedAccountData = getTrimmedObjectValues(formValues);
    const userNameArr = updatedAccountData.userFullName.split(' ');
    updatedAccountData.userFirstName = userNameArr[0];
    updatedAccountData.userLastName = userNameArr?.length > 1 ? userNameArr[userNameArr.length - 1] : '.';
    setAccountData(updatedAccountData);
    setRegistrationStep(steps.CREDENTIALS);
  };

  const handleCancelButtonClick = () => {
    window.location.reload();
  };

  const validate = useValidationSchema(accountValidationSchema);

  return (
    <Form
      validate={validate}
      onSubmit={(formValues) => handleNextButtonClick(formValues)}
      debug={(state, fieldStates) => console.log(state, fieldStates)}
      initialValues={accountData}
      render={({ handleSubmit, valid }) => (
        <form onSubmit={handleSubmit}>
          <div className="flex">
            <Field {...registerFormData.companyName} />
            <Field {...registerFormData.emailAddress} />
          </div>
          <div className="flex margin-2-t">
            <Field {...registerFormData.applUserFullNm} />
            <div className="col-md-6 pad-0-r">
              <Label
                id={`${registerFormData.phoneNo.id}-label`}
                htmlFor={registerFormData.phoneNo.id}
              >
                {labels.CONTACT_PHNO}
                {registerFormData.phoneNo.isRequired ? ' *' : ''}
              </Label>
              <div className="flex">
                <Field {...registerFormData.countryId} options={dialCodes} />
                <Field {...registerFormData.phoneNo} />
              </div>
            </div>
          </div>

          <div className="margin-4-t">
            <FxMultiButtons
              primaryButtonLabel={labels.NEXT}
              isDisablePrimaryButton={!valid}
              secondaryButtonLabel={labels.CANCEL}
              onSecondaryButtonClick={handleCancelButtonClick}
              justifyButtons="end"
            />
          </div>
        </form>
      )}
    />
  );
};

Account.propTypes = {
  accountData: PropTypes.shape({}).isRequired,
  setAccountData: PropTypes.func.isRequired,
  setRegistrationStep: PropTypes.func.isRequired,
  dialCodes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default Account;
